define('modules/page_listing/index',['require','exports','module','base/router','./views/main','common/views/dashboard_layout','./views/page_stats','./collections/pages','./collections/tags','./models/page_stats','./models/querystring','./models/filter','ThemesHelper'],function (require, exports, module) {
  'use strict';

  var Router = require('base/router'),
    PageListingView = require('./views/main'),
    DashboardLayout = require('common/views/dashboard_layout'),
    PageStatsView = require('./views/page_stats'),
    PagesCollection = require('./collections/pages'),
    TagCollection = require('./collections/tags'),
    PageStatsModel = require('./models/page_stats'),
    Querystring = require('./models/querystring'),
    Filters = require('./models/filter'),
    ThemesHelper = require('ThemesHelper');

  module.exports = function (moduleManager) {
    var ModuleRouter = Router.extend({
      routes: {
        '': 'index',
        'pages(?*querystring)': 'index',
        'pages/new/*type': 'newPage',
      },
      pageStatsModel: new PageStatsModel(),
      userTagCollection: new TagCollection(),

      activatePagesTab: function (next) {
        $('.ed-navlink.active').removeClass('active');
        $('.js-pages').addClass('active');
      },

      clearBodyClasses: function () {
        $('body').attr('class', '');
      },

      initialize: function () {
        this.filters = new Filters({ limitPerPage: 5 });
        this.pagesCollection = new PagesCollection({
          querystring: this.filters,
          paginationIsNeeded: true,
        });
      },

      beforeAll: function () {
        var self = this;
        this.filters.set(_.extend(this.filters.defaults, Querystring.parse(arguments[0])));

        this.layout = moduleManager.showInstance(DashboardLayout);
        this.layout.showLoading();

        var pageStats = new PageStatsView({
            pageStatsModel: this.pageStatsModel,
            filters: this.filters,
            userTagCollection: this.userTagCollection,
          }),
          pageListing = new PageListingView({
            collection: this.pagesCollection,
            tags: this.userTagCollection,
            filters: this.filters,
          });

        this.filters.setQueryListener(this, function () {
          this.layout.showLoading();
        });

        this.pagesCollection.on('sync', function () {
          self.layout.$content.show(pageListing);
          const $subNav = self.layout.$el.find('.ed-subnav');

          if ($subNav.length) {
            $subNav.removeClass('hidden');
          }
        });

        this.pagesCollection.on('error', function () {
          self.layout.showError();
        });

        this.activatePagesTab();
        this.clearBodyClasses();
        ThemesHelper.addThemeClass(ThemesHelper.getCurrentTheme());

        this.pageStatsModel.fetch({
          success: function () {
            self.layout.$top.show(pageStats);
          },
        });

        this.pagesCollection.fetch({
          success: function () {
            self.filters.set({
              disabledFilters: false,
            });
          },
          error: function () {
            this.layout.showError();
          },
        });

        return { layout: this.layout, pageListing: pageListing };
      },

      index: function () {
        // Nothing at the moment
      },

      newPage: function (type, views) {
        this.pagesCollection.onReady(function () {
          views.pageListing.newPage(type);
        });
      },
    });

    return new ModuleRouter();
  };
});

